import React from 'react';
import { SettingsAddressForm } from '../../../molecules';
import { State } from '@uplift/api';

type AddressFormSettingsType = {
  states: State[];
};

export const AddressForm: React.VFC<AddressFormSettingsType> = ({ states }) => {

  return <SettingsAddressForm states={states} />;
};
